export const phoneValidator = (str: string): boolean => {
  const americanRegex =
    /^(\+1|1)?[-. ]?\(?([2-9][0-9]{2})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  const intlRegex = /^\+(?:[0-9] ?){6,14}[0-9]$/;
  return americanRegex.test(str) || intlRegex.test(str);
};
